import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavLink } from 'core/types/nav-link';

@Component({
  selector: 'app-dev',
  template: `
      <app-main-layout [navLinks]="navLinks">
      </app-main-layout>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DevLayoutComponent {
  navLinks: NavLink[] = [
    {
      path: '/dev/couriers',
      icon: 'accessible_forward',
      linkActiveOptions: { exact: false },
      label: 'SIDENAV.DEV.couriers',
    },
    {
      path: '/dev/documents',
      icon: 'art_track',
      linkActiveOptions: { exact: false },
      label: 'SIDENAV.DEV.documents',
    },
  ];

  constructor() {
  }
}
